import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import locale from "element-plus/es/locale/lang/zh-cn";
import { createHead } from '@vueuse/head'

const app = createApp(App)
const head = createHead()
app.use(ElementPlus, { locale });
app.use(router);
app.use(head);
app.mount('#app');